// extracted by mini-css-extract-plugin
export default {"wrapper":"GridLayoutModuleWrapper_wrapper__gNnga"};